import { AvailableSetupTypeEnum } from '@doltech/utils/lib/constants';
import { leftPad } from '@doltech/utils/lib/number';
import { isNotEmpty } from '@doltech/utils/lib/text';
import { getParent, getRoot, Instance, types as t } from 'mobx-state-tree';

import { ERROR_NEED_OVERRIDE } from '../../../question-data-model/constants';
import { AbstractQuestion } from '../../../question-data-model/Question/abstract-question.store';

export const AdminAbstractQuestion = AbstractQuestion.named('AdminAbstractQuestion')
  .props({
    question: t.maybeNull<any>(t.string),
    currentCorrectionIndex: 0,
  })
  .actions((self) => ({
    setQuestion(text: string) {
      self.question = text;
    },
    setCurrentCorrectionIndex(index: number) {
      self.currentCorrectionIndex = index;
    },
  }))
  /** PLEASE IMPLEMENT BELOW FUNCTION FOR NEW QUESTION TYPE
      get isCompleted()
      get isDirty()
      get corrections() to get specific corrections for each question type
      get prepareQuestionForSubmit() to get specific question for each question type to prepare payload
      get explanationKeys() to get key and display key for explanation viewer

      getDefaultGuideline() default guideline for this question (match with figma design)
      questionCount() some question contains a lot of question no, usually you need to return 1 for simple question (SingleQuestion/TFN QuestionMobile/YNN QuestionMobile)
      preparePayloadForSubmit() to prepare data before publish the test
   */
  .views(function protectedViews(self) {
    return {
      get availableOnSetupType(): AvailableSetupTypeEnum[] {
        throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
      },
      get isCompleted(): boolean {
        throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
      },
      get isDirty(): boolean {
        throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
      },
      get explanationKeys(): Array<number> {
        throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
      },
      get corrections(): any {
        throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
      },
      prepareQuestionForSubmit(): any {
        throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
      },
      questionCount(): number {
        throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
      },
      getDefaultGuideline() {
        throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
      },
      preparePayloadForSubmit() {
        throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
      },
    };
  })
  .views((self) => ({
    get isQuestionBelongToSetupType(): boolean {
      const root: any = getRoot(self);
      const testSetupType = root.createTestSectionStore?.testSection?.factory?.type;
      return self.availableOnSetupType.includes(testSetupType);
    },
    getCurrentCorrection() {
      const findFirstCorrection = self?.corrections?.find(
        (_co, coIndex) => coIndex === self.currentCorrectionIndex
      );
      if (findFirstCorrection) {
        return findFirstCorrection;
      }
      return (self?.corrections || []).filter(Boolean)[0];
    },

    get isRemovable(): boolean {
      const questions: any[] = getParent(self);
      return questions.length > 1;
    },
    get isActive() {
      const group = getParent<any>(self, 2);
      return group.isActive && group.currentQuestion === self;
    },
    get no() {
      const testSection: any = getParent(self, 4);

      let questionNo = 1;
      let isFound = false;
      testSection.groups.forEach((group) => {
        group.questions.forEach((question) => {
          if (question.uuid === self.uuid) {
            isFound = true;
          }
          if (!isFound) {
            questionNo += question.questionCount();
          }
        });
      });

      return questionNo;
    },
    isDirtyFn() {
      return isNotEmpty(self.question);
    },
  }))
  .views((self) => ({
    toOrdinalString(options = { pad: true }) {
      const { pad } = options;
      const start = self.no;
      const end = start + self.questionCount() - 1;

      if (self.questionCount() > 1) {
        return pad ? `${leftPad(start)} - ${leftPad(end)}` : `${start} - ${end}`;
      }
      return pad ? leftPad(start) : start;
    },
    getTotalQuestion() {
      return self.questionCount();
    },
  }));

export interface AdminAbstractQuestionInstance extends Instance<typeof AdminAbstractQuestion> {}
